// extracted by mini-css-extract-plugin
export default {"contentCol":"CategoriesSec_contentCol__AgokG","swiper_box":"CategoriesSec_swiper_box__7Jwzd","swiperSlide":"CategoriesSec_swiperSlide__d9Bh3","box":"CategoriesSec_box__ZuY8x"};